export class MotorAddressMdl
{
   public Insured_AreaName: string;
   public Insured_BuildingNo: string;
   public Insured_UnitNo: string;
   public Insured_StreetName: string;
   public Insured_DistName: string;
   public Insured_AdditionalCode: string;

   public Insured_WAdditionalCode: string;
   public  Insured_WAreaName: string;
   public Insured_WBuildingNo: string;
   public Insured_WCity: string;
   public  Insured_WPostalCode: string;
   public Insured_POPostalCode: string;
   public Insured_POCity: string;
   public Insured_WorkPlace: string;
   public  Insured_City: string;
   public Insured_RegionCode: string;
   public Insured_RegionName: string;
   public  Insured_RegionName_Ar: string;
   public  Insured_Nationality: string;
   public Insured_Nationality_En: string;
   public Insured_Nationality_Ar: string;
   public Insured_NationalityExists:boolean;
   public Insured_PostalCode: string;
   public Insured_POBoxNo: string;
   public Insured_Address1: string;
   public Insured_Address2: string;
   public InsuredAddressType:string;
   public WaselAddress: boolean;
   public POBoxAddress: boolean;

   public CityExists: boolean;
   public additionalNumberExists: boolean;
   public buildingNumberExists: boolean;
   public districtExists: boolean;
   public postCodeExits: boolean;
   public streetNameExists: boolean;

   public OfficePostalCode: string;
   public OfficeBuildingNo: string;
   public OfficeAdditionalCode: string;
   public OfficeCity: string;
   public OfficeDistrict: string;
   public OfficeRegionCode: string;
   public OfficeStreet: string;
   public officeAddr: boolean;
   public OfficeZone:string;
   public OfficeUnitNo: number;
   
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/MotorAddressMdl.ts